'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _interopRequireDefault = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _React = require('react');

var _React2 = _interopRequireDefault(_React);

var _classNames = require('classnames');

var _classNames2 = _interopRequireDefault(_classNames);

var Table = _React2['default'].createClass({
  displayName: 'Table',

  propTypes: {
    striped: _React2['default'].PropTypes.bool,
    bordered: _React2['default'].PropTypes.bool,
    condensed: _React2['default'].PropTypes.bool,
    hover: _React2['default'].PropTypes.bool,
    responsive: _React2['default'].PropTypes.bool
  },

  render: function render() {
    var classes = {
      table: true,
      'table-striped': this.props.striped,
      'table-bordered': this.props.bordered,
      'table-condensed': this.props.condensed,
      'table-hover': this.props.hover
    };
    var table = _React2['default'].createElement(
      'table',
      _extends({}, this.props, { className: _classNames2['default'](this.props.className, classes) }),
      this.props.children
    );

    return this.props.responsive ? _React2['default'].createElement(
      'div',
      { className: 'table-responsive' },
      table
    ) : table;
  }
});

exports['default'] = Table;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/Table.js
 ** module id = 243
 ** module chunks = 0
 **/